module.exports = __webpack_public_path__ + "static/media/title.a233fd90.png";